import _ from 'lodash'
// import qs from 'qs'
import axios from 'axios'
import './enhancedAxios'
import Api, { link } from 'redux-apis'
import Async from 'redux-async-api'

import { SaltError } from './errors'
import Minions from './Minions'
import Keys from './Keys'
import Jobs from './Jobs'
import Docs from './Docs'

import {
  isAuthenticatedCheck,
  setStateChanges as _setStateChanges,
  setBusy as _setBusy, setDone as _setDone, setError as _setError,
  normalizeMinions, normalizeJobs
} from './commonUtils'

import axios_mock_create from './mock'

// export const isAuthenticatedCheck = (auth, now) => (
//   (auth && auth.token && auth.expire &&
//    auth.expire > ((now ? now : Date.now()) / 1000)) ||
//   false)

export default class SaltApi extends Api {

  constructor(settings, allDocs, state = {...SaltApi.INITIAL_STATE}) {
    state = _.extend({}, SaltApi.INITIAL_STATE, state, {
      saltMasterMinionId: ( settings.SALT_MASTER_MINION_ID ||
                            SaltApi.INITIAL_STATE.saltMasterMinionId ),
      saltBaseURL: ( settings.SALT_BASE_URL ||
                     SaltApi.INITIAL_STATE.saltBaseURL )
    })

    super(state)

    // setup Axios
    if(settings.USE_MOCK) {
      this.aio = axios_mock_create({
        baseURL: state.saltBaseURL || settings.SALT_BASE_URL || '',
        timeout: settings.TIMEOUT,
        headers: settings.HEADERS,
        withCredentials: settings.withCredentials || true
      })
    } else {
      this.aio = axios.create({
        baseURL: state.saltBaseURL || settings.SALT_BASE_URL || '',
        timeout: settings.TIMEOUT,
        headers: settings.HEADERS,
        withCredentials: settings.withCredentials || true
      })
    }
    this._saltMasterMinionId = settings.SALT_MASTER_MINION_ID
    this._saltBaseURL = settings.SALT_BASE_URL
    this._tryAuthFromStorages = settings.tryAuthFromStorages
    this._saveCredsToLocalStorage = settings.saveCredsToLocalStorage
    this._creds = {}
    this._filteredJobs = null

    this._evtSource = null
    this._evtSourceRetryTimer = null
    this._evtSourceMaxRetryTimes = 5
    this._evtSourceRetryDelay = 5000
    this._evtSourceRetried = 0

    // processing events we track interesting jobs
    this._interestingPendingJobs = {}  // we should keep the size checked

    this.__allDocs = allDocs
    this._docs = link(this, new Docs(this))
    this._keys = link(this, new Keys(this))
    this._minions = link(this, new Minions(this))
    this._jobs = link(this, new Jobs(this))

    this.async = link(this, new Async())
    this._prevent_async_status_changes = false

    // this._keys = link(this, new Keys(this.aio))
    // this._minions = link(this, new Minions(this.aio))
    this._prevent_any_status_changes = false

    // this.setStateChanges = _setStateChanges.bind(this)
    // this.setBusy = _setBusy.bind(this)
    // this.setDone = _setDone.bind(this)
    // this.setError = _setError.bind(this)

    //this.__cachedMinions = null
    // define properties mapped on state tree branches
    Object.defineProperties(this, {
      saltMasterMinionId: { enumerable: true, get: () => this.getState().saltMasterMinionId},
      saltBaseURL: { enumerable: true, get: () => this.getState().saltBaseURL },

      setStateChanges: { enumerable: false, get: () => _setStateChanges.bind(this) },
      setBusy: { enumerable: false, get: () => _setBusy.bind(this) },
      setDone: { enumerable: false, get: () => _setDone.bind(this) },
      setError: { enumerable: false, get: () => _setError.bind(this) },

      auth: { enumerable: true, get: () => this.getState().auth },
      availableClients: { enumerable: true, get: () => this.getState().clients },
      stats: { enumerable: true, get: () => this.getState().stats },

      // __keys: { enumerable: false, get: () => this.getState().keys },
      keys: { enumerable: true, get: () => this._keys.getState() },
      docs: { enumerable: true, get: () => this._docs.getState() },

      grains: { enumerable: true, get: () => this._minions.getState().grains },
      statuses: { enumerable: true, get: () => this._minions.getState().status },
      minions: {
        enumerable: true, get: () => (
          normalizeMinions(this._minions.getState(), this._keys.getState())
        )
      },

      // allJobs: { enumerable: true, get: () => this.getState().jobs },
      pendingJobsIds: { enumerable: true, get: () => this.getState().pendingJobsIds },
      completedJobsIds: { enumerable: true, get: () => this.getState().completedJobsIds },
      jobs: { enumerable: true, get: () => (normalizeJobs(this._jobs.getState())) },
    })

    // Action handlers (reducers)
    this.setHandler('SET_AUTH', (state, action) => ({...state, auth:action.payload}))
    this.setHandler('SET_AVAILABLE_CLIENTS', (state, action) => ({...state, clients:action.payload}))
    this.setHandler('SET_STATS', (state, action) => ({...state, stats:action.payload}))

    // this.setHandler('SET_KEYS', (state, action) => ({...state, __keys:action.payload}))

    // this.setHandler('SET_GRAINS', (state, action) => ({...state, grains:action.payload}))
    // this.setHandler('SET_STATUS', (state, action) => ({...state, status:action.payload}))

    // this.setHandler('SET_MINION_KEYS', (state, action) => ({...state, minionKeys:action.payload || {}}))
    // // for minions we have to merge because first level of tree is shared by several action
    // this.setHandler('SET_MINION_GRAINS', (state, action) => ({...state, minions:_.merge(state.minions || {}, action.payload)}))
    // this.setHandler('SET_MINION_STATUS', (state, action) => ({...state, minions:_.merge(state.minions || {}, action.payload)}))
    // // for jobs we can just overrid (extending actual state tree)
    // this.setHandler('SET_JOBS', (state, action) => {
    //   //console.log('SET_JOBS', state, action, state.jobs, state.allJobs);
    //   this._filteredJobs = null
    //   return ({...state, jobs:_.merge(state.jobs || {}, action.payload)})
    // })
    // // this.setHandler('SET_JOBS_RESULTS', (state, action) => {
    // //   this._filteredJobs = null
    // //   return ({...state, jobs:_.merge(state.jobs || {}, _
    // //     .chain(action.payload)
    // //     .map((v, k) => (_.isString(k) && _.isObject(v)) ? [k, { Result: v }] : undefined)
    // //     .filter()
    // //     .fromPairs()
    // //     .value())})
    // // })
    this.setHandler('JOB_STARTED', (state, action) => {
      let pending = new Set(state.pendingJobsIds)
      pending.add(action.payload)
      return ({...state, pendingJobsIds:Array.from(pending)})
    })
    this.setHandler('JOB_COMPLETED', (state, action) => {
      let pending = new Set(state.pendingJobsIds)
      let completed = new Set(state.completedJobsIds)
      pending.delete(action.payload)
      completed.add(action.payload)
      return ({...state, pendingJobsIds:Array.from(pending), completedJobsIds:Array.from(completed)})
    })

    // this._tryAuthFromStorage = this._tryAuthFromStorage.bind(this);
  }

  // init() {
  //   const _this = Api.prototype.init.call(this)
  //   console.log('SaltApi.init:', _this, _this === this)
  //   return this
  // }


  // state changes management
  // setBusy() {
  //   return _setBusy.bind(this)()
  //   if (!this._prevent_async_status_changes &&
  //       !this._prevent_any_status_changes)
  //     if (!this.async.busy) this.async.setBusy()
  // }
  // setDone() {
  //   return _setDone.bind(this)()
  //   if (!this._prevent_async_status_changes &&
  //       !this._prevent_any_status_changes)
  //     if (!this.async.done) this.async.setDone()
  // }
  // setError(err) {
  //   return _setError.bind(this)(err)
  //   if (!this._prevent_async_status_changes &&
  //       !this._prevent_any_status_changes)
  //     this.async.setError(err)
  //   else
  //     throw err
  // }

  // setStateChanges(handlers, payloads) {
  //   return _setStateChanges.bind(this)(handlers, payloads)
  //   if (this._prevent_any_status_changes) return
  //   if (_.isString(handlers)) {
  //     handlers = [handlers]
  //     payloads = [payloads]
  //   }
  //   _.forEach(handlers, (handler, i) => {
  //     if (_.isFunction(this.__actionHandlers[handler]))
  //       this.dispatch(this.createAction(handler)(payloads[i]))
  //   })
  // }


  // initialize Docs
  initDocs() {
    if(_.isUndefined(this.__allDocs)) return
    this._docs.initDocs(this.__allDocs)
    delete this.__allDocs
  }

  // misc generic api call
  getWelcome() {
    this.setBusy()
    return this
      .aio.get('/')
      .then(res => {
        console.log('getWelcome res:', res)
        this.setStateChanges('SET_AVAILABLE_CLIENTS', res.data.clients)
        this.setDone()
        return res.data.return
      })
      .catch(err => {
        err = new SaltError(err)
        this.setError(err)
      })
  }

  getStats() {
    this.setBusy()
    return this
      .aio.get('/stats')
      .then(res => {
        // console.log('getStats res:', res)
        this.setStateChanges('SET_STATS', res.data)
        this.setDone()
        return res.data
      })
      .catch(err => {
        err = new SaltError(err)
        this.setError(err)
      })
  }


  // auth related utils and login/logout
  _tryAuthFromStorage(storage) {
    if (storage['saltreact_auth'] !== undefined) {
      let auth
      try {
        auth = JSON.parse(storage['saltreact_auth'])
      } catch (e) {
        console.error(e)
      }
      // if (storage['saltreact_creds'] !== undefined)  {
      //   try {
      //     let creds = JSON.parse(storage['saltreact_creds'])
      //     if (creds.username == auth.user)
      //       this._creds = creds
      //     else {
      //       this._creds = {}
      //       delete storage['saltreact_creds']
      //     }
      //   } catch (e) {
      //     console.error(e)
      //   }
      // }
      // if (auth !== undefined)
      //   this.setAuth(auth)
      return auth
    }
  }

  isAuthenticated(now) {
    let isok = false, storedAuth = {}
    now = now || Date.now()
    if (_.size(this.auth) === 0 && this._tryAuthFromStorages) {
      if (this._saveCredsToLocalStorage)
        storedAuth.local = this._tryAuthFromStorage(localStorage)
      storedAuth.session = this._tryAuthFromStorage(sessionStorage)
      // console.log('isAuthenticated?: ', storedAuth);
      storedAuth = storedAuth.session || storedAuth.local
      // console.log('isAuthenticated?: ', storedAuth);

      isok = isAuthenticatedCheck(storedAuth, now)
      if (isok) this.setAuth(storedAuth)
      // console.log('isAuthenticated?: ', isok)
      return isok
    }

    isok = isAuthenticatedCheck(this.auth, now)
    if (!isok) this.setAuth(this.auth)
    // console.log('isAuthenticated?: ', isok)
    return isok
  }

  setAuth(auth) {
    if (_.size(auth)) {
      sessionStorage['saltreact_auth'] = JSON.stringify(auth)
      if (this._saveCredsToLocalStorage)
        localStorage['saltreact_auth'] = JSON.stringify(auth)
      // if ((_.size(this._creds))) {
      //   sessionStorage['saltreact_creds'] = JSON.stringify(this._creds)
      //   if (this._saveCredsToLocalStorage)
      //     localStorage['saltreact_creds'] = JSON.stringify(this._creds)
      // }
      this.aio.defaults.headers['X-Auth-Token'] = auth.token
    } else {
      delete sessionStorage['saltreact_auth']
      //delete sessionStorage['saltreact_creds']
      delete localStorage['saltreact_auth']
      //delete localStorage['saltreact_creds']

      this._creds = {}
      delete this.aio.defaults.headers['X-Auth-Token']
    }
    return this.setStateChanges('SET_AUTH', auth)
  }


  login (user, pass){
    let data = {
      username: user, password: pass, eauth: 'pam'
    }
    this.setBusy()
    return this
      .aio.post('/login', data)
      .then(r => {
        let res = r.data.return[0]
        // this._creds = data
        this.setAuth(res)
        this.setDone()
      })
      .catch(err => {
        err = new SaltError(err)
        this.setAuth({})
        this.setError(err)
        // throw err
      })
  }

  logout (){
    this.setBusy()
    this.dropEventSource()
    return this.aio.post('/logout').then(
      () => {
        this.setAuth({})
        this.setDone()
        console.log('logout done')
      }
    ).catch(err => {
      this.setAuth({})
      // err = new SaltError(err)
      // this.setError(err)
      this.setDone()
      console.log('logout error', err)
      // throw err
    })
  }


  // keys and minions simple api calls and utils
  getKeys(mid) {
    this.setBusy()
    return this
      ._keys.getKeys(mid)
      .then(res => {
        this.setDone()
        return res
      })
  }

  getStatus(mid) {
    this.setBusy()
    return this
      ._minions.getStatus(mid)
      .then(res => {
        this.setDone()
        return res
      })
  }

  getGrains(mid) {
    this.setBusy()
    return this
      ._minions.getGrains(mid)
      .then(res => {
        this.setDone()
        return res
      })
  }

  getAllMinionsKeysAndGrainsAndStatus () {
    this.setBusy()
    this._prevent_any_status_changes = true
    //console.log('_minions: ', mid);
    return Promise.all([
      this._keys.getKeys('*'),
      this._minions.getGrains(),
      this._minions.getStatus()
    ]).then(results => {
      // console.log('GOT MINION', results)
      let [ keys, grains, status ] = results
      this._prevent_any_status_changes = false
      // this.setStateChanges(['SET_KEYS', 'SET_GRAINS', 'SET_STATUS'], [keys, grains, status])
      this._keys.setStateChanges(['SET_KEYS'], [keys])
      this._minions.setStateChanges(['SET_GRAINS', 'SET_STATUS'], [grains, status])
      //this._prevent_async_status_changes = false
      this.setDone()
      return _
        .chain(keys.minions)
        .map((fp, mid) => {
          return [mid, {
            fp: fp,
            grains: grains[mid] || {},
            status: status[mid] || false,
          }]
        })
        .fromPairs()
        .value()
    }).catch(err => {
      this._prevent_any_status_changes = false
      //this._prevent_async_status_changes = false
      this.setError(err)
    })
  }

  getMinionsInitialStatus() {
    this.setBusy()
    this._prevent_any_status_changes = true
    //console.log('_minions: ', mid);
    return Promise.all([
      this._keys.getKeys('*'),
      this._minions.getStatus()
    ]).then(results => {
      // console.log('GOT MINION', results)
      let [ keys, status ] = results
      this._prevent_any_status_changes = false
      this._keys.setStateChanges(['SET_KEYS'], [keys])
      this._minions.setStateChanges(['SET_STATUS'], [status])
      this.setDone()
      return _
        .chain(keys.minions)
        .map((fp, mid) => {
          return [mid, {
            fp: fp,
            status: status[mid] || false,
          }]
        })
        .fromPairs()
        .value()
    }).catch(err => {
      this._prevent_any_status_changes = false
      this.setError(err)
    })
  }


  // generic '/' endpoint to start jobs and other ...

  // usable salt modules are https://docs.saltstack.com/en/latest/salt-modindex.html#cap-m
  // the params object:
  // (have to follow this protocol https://docs.saltstack.com/en/latest/ref/clients/index.html#salt.client.LocalClient.cmd )
  // arg and kwarg are optional deplending on the codule.function
  // arg: a string or a list of strings (or a list of lists if a compound command (list of mod and fun on list of tgt)
  // kwarg: an object
  _parseParamsSingleFun(arg, kwarg) {
    console.debug(`arg?: ${arg}`, `kwarg: ${kwarg}`)
    let params = ( _.isObject(arg) && kwarg === undefined ) ? {kwarg: arg} : {}
    if (arg) params.arg = arg
    if (kwarg) params.kwarg = kwarg
    return params


    // let params = {}
    // if (arg) {
    //   if (_.isString(arg))
    //     params.arg = arg
    //   else {
    //     if (_.isArray(arg))
    //       params.arg = arg
    //     else
    //       params.arg = [arg];

    //     if (kwarg) {
    //       params.arg = (params.arg || []).concat(
    //         qs.stringify(
    //           _.pickBy(kwarg, v => {
    //             return _.isString(v) || _.isNumber(v)
    //           })).split('&'));
    //     }
    //     params = qs.stringify(params)
    //     console.debug(`arg is not a string: ${params}`)
    //   }
    // } else if (kwarg) { // TODO VERIFY
    //   params.kwarg = _.pickBy(kwarg, v => {
    //     return _.isString(v) || _.isNumber(v) || _.isBoolean(v)
    //   })
    //   console.debug(`arg is undefined: ${params}`)
    // }
    // return params
  }

  _run(tgt, fun, arg, kwarg, expr_form = 'glob', client = 'local') {
    let data = {
      client: client,
      expr_form: expr_form,
      tgt: tgt,
      fun: fun,
      ...this._parseParamsSingleFun(arg, kwarg)
    }
    console.log('_run: ', data)
    this.setBusy()
    return this
      .aio.post('/', data)
      .then(r => {
        console.log('_run', r)
        let res = r.data.return[0]
        if (client === 'local_async') {
          this.dispatch(this.createAction('JOB_STARTED')(res.jid))
          this.setDone()
          return res.jid
        }
        this.setDone()
        return res
      })
      .catch(err => {
        err = new SaltError(err)
        this.setError(err)
        // throw err
      })
  }

  _runAsync(tgt, fun, arg, kwarg, expr_form = 'glob') {
    return this._run(tgt, fun, arg, kwarg, expr_form, 'local_async')
  }

  _runOnMaster(fun, arg, kwarg, client = 'local') {
    return this._run(this._saltMasterMinionId, fun, arg, kwarg, 'glob', client)
  }

  ping(tgt, expr_form = 'glob') {
    return tgt ? this._run(
      tgt, 'test.ping', null, null, expr_form) : this._run('*', 'test.ping')
  }


  getJobs(jid) {
    this.setBusy()
    return this
      ._jobs.getJobs(jid)
      .then(res => {
        this.setDone()
        return res
      })
  }


  // Events management (at /events endèpoint) SSE
  getEventSourceURL(baseURL) {
    baseURL = baseURL||this.aio.defaults.baseURL
    return `${baseURL}/events?token=${this.auth.token}`
  }

  createEventSource(onOpen, onError, onMessage, baseURL) {
    const source = new EventSource(
      this.getEventSourceURL(baseURL), {withCredentials: true})
    source.onopen = _.isFunction(onOpen) ? onOpen : () => null
    source.onerror = _.isFunction(onError) ? onError : () => null
    source.onmessage = _.isFunction(onMessage) ? onMessage : () => null
    return source
  }

  _clearEventSourceRetryTimer() {
    if (this._evtSourceRetryTimer !== null) {
      clearTimeout(this._evtSourceRetryTimer)
      this._evtSourceRetryTimer = null
    }
    this._evtSourceRetried = 0
  }

  setEventSource(
    onOpen, onError, onMessage, baseURL,
    processEvent = true, reopenOnError = true
  ) {
    this._clearEventSourceRetryTimer()
    if (_.isFunction((this._evtSource||{}).close))
      this._evtSource.close()

    let onMsgCallback = onMessage
    let onErrCallback = onError
    if (processEvent) {
      onMsgCallback = (msg) => {
        try {
          this.processEvent(JSON.parse(msg.data))
        } catch (e) {
          console.error('malformed json in message ???')
          console.error(e)
        }
        _.isFunction(onMessage) && onMessage(msg)
      }
    }
    // if (reopenOnError) {
    //   onErrCallback = () => {
    //     this._clearEventSourceRetryTimer()
    //     setTimeout(() => {}, this._evtSourceRetryDelay)
    //     onError()
    //   }
    // }

    this._evtSource = this.createEventSource(onOpen, onErrCallback, onMsgCallback, baseURL)
  }

  getEventSource(onOpen, onError, onMessage, baseURL, processEvent = true, reopenOnError = true) {
    if (this._evtSource && this._evtSource.readyState !== this._evtSource.CLOSED)
      return this._evtSource
    this.setEventSource(onOpen, onError, onMessage, baseURL, processEvent, reopenOnError)
    return this._evtSource
  }

  dropEventSource() {
    this._clearEventSourceRetryTimer()
    if (_.isFunction((this._evtSource||{}).close))
      this._evtSource.close()
    this._evtSource = null
  }

  processEvent(event) {
    let { tag, data } = event
    console.log('processEvent:', tag, data)
    if (tag.startsWith('salt/job/')) {
      let jobType = tag.substr(('salt/job/' + data.jid + '/').length)
      this._processEventJob(jobType, data)
    }
    // other kinds on event to process ...
  }

  _transformEventJobNewToInterestingJobsFormat(job) {
    return {
      'Target-Type': job.tgt_type,
      Target: job.tgt,
      start_stamp: job._stamp, // TODO: convert to StartTime format (getJobs)
      Function: job.fun,
      Arguments: job.arg,
      User: job.user
    }
  }
  _processEventJob(type, data) {
    // if (data.user !== this.auth.user) return // track only mine ones
    console.log(type)
    if (type === 'new' && data.user === this.auth.user) {
      // some job is just started, let's see if a retrive or is a real job we would have to track
      if (data.fun !== 'saltutil.find_job') {
        // is a proper interesting job
        let interestingJob = this._transformEventJobNewToInterestingJobsFormat(data)
        // let's track the interesting job
        // we are waiting for _.size(data.minions) events
        // before to mark is as completed
        this._interestingPendingJobs = _.extend(this._interestingPendingJobs, {
          [data.jid]: {
            waitingFor: new Set(data.minions), // the minions ids
            jid: data.jid,
            job: interestingJob,
            partialResult: {},
            completed: false,
            sync: false  // let's assume this is an async job the we are to mark as completed
          }
        })


        // interestingJob is what getJobs would return for this jid
        // let's anticipate a getJobs call
        if (_.size(this._interestingPendingJobs) > 10) {
          let missingJobIds = _.difference(_.keys(this._interestingPendingJobs), _.keys(this.allJobs))
          if (missingJobIds.length > 0) {
            let jobsToAdd = _.pick(this._interestingPendingJobs, missingJobIds)
            jobsToAdd = _
              .chain(jobsToAdd)
              .map((v, k) => [k, v.job])
              .fromPairs()
              .value()
            this.dispatch(this.createAction('SET_JOBS')(jobsToAdd))
          }
        }

      } else { // it is a 'saltutil.find_job'
        // this new job is to find a synchronous running job,
        // so we won't have to mark it as completed
        // just check if we are already tracking it,
        // would be wierd if we don't, but this could be the last chance to track it
        let syncJob = this._interestingPendingJobs[data.arg[0]]
        if (_.isObject(syncJob)) {
          // just mark it as sync so we won't complete it
          syncJob.sync = true
        } else if (this.allJobs[data.arg[0]] === undefined) {
          // this is wierd, we have to add it to the store (allJobs),
          // the result will be added, in case, at the next getJob(<syncJob jid>)
          // TODO Transorm saltutil.find_job result in a tracked interesting job format
          // end track it
          /*
             {
             "tgt_type": "list",
             "jid": "20170717013218172157",
             "tgt": [
             "jmini.bardels.me",
             "homer.bardels.me",
             "osmc.tirana",
             "lisa.bardels.me"
             ],
             "_stamp": "2017-07-16T23:32:18.177584",
             "user": "mbj",
             "arg": [
             "20170717013213008342"
             ],
             "fun": "saltutil.find_job",
             "minions": [
             "jmini.bardels.me",
             "homer.bardels.me",
             "osmc.tirana",
             "lisa.bardels.me"
             ]
             }
           */
          //
          // let untrackedJob = this._transformEventJobNewFromFindJobToInterestingJobsFormat(data.<something>)
          // this.dispatch(this.createAction('SET_JOBS')({[data.arg[0]]: untrackedJob}))
          //
        }
      }
    } else if (type.startsWith('ret/') && this._interestingPendingJobs[data.jid]) {
      // a job or a part of is returning
      // just decrement the waitingFor of the tracked job
      if (data.fun === 'saltutil.find_job')  {
        // should we manage this ?? we could store some job information if it is not yet tracked
        /*
           {
           "fun_args": [
           "20170717014042827238"
           ],
           "jid": "20170717014058017850",
           "return": {
           "tgt_type": "glob",
           "jid": "20170717014042827238",
           "tgt": "*",
           "pid": 28285,
           "ret": "",
           "user": "mbj",
           "arg": [
           "sleep 20 ; echo Ciao"
           ],
           "fun": "cmd.run"
           },
           "retcode": 0,
           "success": true,
           "cmd": "_return",
           "_stamp": "2017-07-16T23:40:58.689084",
           "fun": "saltutil.find_job",
           "id": "jmini.bardels.me"
           }
         */
        // let untrackedJob = this._transformEventJobRetFromFindJobToInterestingJobsFormat(data.<something>)
        // this.dispatch(this.createAction('SET_JOBS')({[data.arg[0]]: untrackedJob}))
      } else {
        // get the tracked pending job reference
        let trackedJob = this._interestingPendingJobs[data.jid]
        console.log('/ret/', trackedJob, data.id)
        if (trackedJob.waitingFor.has(data.id)) {
          // collect its partial result
          /*
             {
             "fun_args": [
             "/asassa"
             ],
             "jid": "20170717020731129642",
             "return": false,
             "retcode": 0,
             "success": true,
             "cmd": "_return",
             "_stamp": "2017-07-17T00:07:33.267225",
             "fun": "file.file_exists",
             "id": "jmini.bardels.me"
             }
             or
             {
             "fun_args": [
             "sleep 10 ; ls /asassa >/dev/null"
             ],
             "jid": "20170717020303335163",
             "return": "ls: cannot access /asassa: No such file or directory",
             "retcode": 2,
             "success": true,
             "cmd": "_return",
             "_stamp": "2017-07-17T00:03:13.819744",
             "fun": "cmd.run",
             "id": "osmc.tirana"
             }
           */
          trackedJob.partialResult[data.id] = data

          // this minion has finished
          trackedJob.waitingFor.delete(data.id)
        }
        // check if this job has to be marked as completed
        if (_.size(trackedJob.waitingFor) === 0) {
          // all minions returned
          trackedJob.completed = true
          if (trackedJob.sync === false) {
            // we have to JOB_COMPLETE it
            let pending = new Set(this.pendingJobsIds)
            if (pending.has(trackedJob.jid)) {
              this.dispatch(this.createAction('JOB_COMPLETED')(trackedJob.jid))
            } else {
              // this is really wierd, an async job returned
              // before the start was notified and stored
              this.dispatch(this.createAction('JOB_COMPLETED')(trackedJob.jid))
            }
          }

          // let's anticipate a getJob(<id>) call, and remove all completed tracked job
          // if (_.size(this._interestingPendingJobs) > 10) {
          //   let completedJobs = _.filter(this._interestingPendingJobs, ['completed', true])
          //   if (completedJobs.length > 0) {
          //     let jobsToAdd = _
          //       .chain(completedJobs)
          //       .map(completedJob => {
          //         let res = {
          //           Result: _
          //             .chain(completedJob.partialResult)
          //             .map((res, mid)  => [mid, res.return])
          //             .fromPairs()
          //             .value()
          //         }
          //         if (completedJob.job.fun.startsWith('cmd'))
          //           res.ReturnCode = _
          //             .chain(completedJob.partialResult)
          //             .map((res, mid)  => [mid, res.retcode])
          //             .fromPairs()
          //             .value()
          //         return [completedJob.jid , _.extend(completedJob.job, res)]
          //       })
          //       .fromPairs()
          //       .value()
          //     this.dispatch(this.createAction('SET_JOBS')(jobsToAdd))
          //   }
          // }

        }
      }
    }
    // what else ???
  }

}


SaltApi.INITIAL_STATE = {
  saltMasterMinionId: '',
  saltBaseURL: '',
  auth: {},
  keys: {},
  minions: {},
  grains: {},
  status: {},
  jobs: {}
}



// WEBPACK FOOTER //
// ./src/saltapi/SaltApi.js